export const GET_PROFILE = 'GET_PROFILE';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';